"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/Row.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');



var _navigation = require('web/actions/navigation');
var _phone = require('shared/services/phone');

var _RecipientTable = require('web/screens/Broadcast/RecipientTable');
var _useMessageCells = require('web/screens/Broadcast/RecipientTable/useMessageCells'); var _useMessageCells2 = _interopRequireDefault(_useMessageCells);
var _patientText = require('web/screens/Broadcast/Wizard/Recipients/patientText');












/* A variable's cell, as the recipients screen shows it (review R800-74): the
 * recipient's value; else Missing when the server says sending needs one;
 * else what they get instead (the token's fallback, then the variable's
 * default); else —. */
const VariableCell = ({ column, row }) => {
  const value = row.Values[column.name]
  if (_optionalChain([value, 'optionalAccess', _ => _.trim, 'call', _2 => _2()])) {
    return _react2.default.createElement('td', { className: "campaign--table--col-variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}, _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 31}},  value ))
  }
  if (row.Missing.includes(column.name)) {
    return (
      _react2.default.createElement('td', { className: "campaign--table--col-variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}
        , _react2.default.createElement('span', { className: "campaign--table--value-missing", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, "Missing")
      )
    )
  }
  return (
    _react2.default.createElement('td', { className: "campaign--table--col-variable", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      ,  column.fallback !== null
        ? _react2.default.createElement('span', { className: "campaign--table--value-default", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}},  column.fallback )
        : _react2.default.createElement('span', { className: "campaign--table--value-none", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "—")
      
    )
  )
}

const displayName = (row) =>
  [row.FirstName, row.LastName].filter(Boolean).join(' ') || row.Phone || row.Email || 'Unnamed patient'

/* One recipient of the blocked-recipients review (M5, P3'). */
const Row = ({
  orgKey,
  row,
  isSelected,
  onToggleSelection,
  columns,
}) => {
  const patientKey = _optionalChain([row, 'access', _3 => _3.Patient, 'optionalAccess', _4 => _4.PatientKey])
  const cells = _useMessageCells2.default.call(void 0, row.Status
    ? { Status: row.Status, ScheduledAt: row.ScheduledAt, SentAt: row.SentAt, ErrorCode: row.ErrorCode }
    : null)
  const name = row.Patient ? displayName(row) : 'Deleted patient'
  return (
    _react2.default.createElement(_RecipientTable.RecipientRow, {
      selection: onToggleSelection ? { isSelected, onToggle: onToggleSelection, label: `Select ${name}` } : null,
      onClick: onToggleSelection ? () => onToggleSelection(!isSelected) : undefined,
      avatarKey: _nullishCoalesce(patientKey, () => ( name)),
      name: patientKey
        ? (
            _react2.default.createElement(_reactrouterdom.Link, {
              to: _navigation.makePatientPageRoute.call(void 0, orgKey, patientKey),
              className: "campaign--table--col-name--label",
              onClick: e => e.stopPropagation(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}

              ,  name 
            )
          )
        : name,
      dob: _patientText.formatDob.call(void 0, row.DOB),
      contact: _phone.formatPhoneNumber.call(void 0, row.Phone) || row.Phone || row.Email,
      variableCells: columns.map(c => _react2.default.createElement(VariableCell, { key: c.name, column: c, row: row, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}} )),
      ...cells, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
    )
  )
}

exports. default = _react.memo.call(void 0, Row)
